function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_421_3610)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.061 17.872a.496.496 0 00.001.7l6.037 6.051a.506.506 0 00.715 0l6.04-6.053a.496.496 0 00.004-.698l-.74-.758a.506.506 0 00-.72-.003l-3.918 3.933V10.173c0-.276-.225-.5-.503-.5h-1.04a.501.501 0 00-.503.5v10.87l-3.9-3.933a.506.506 0 00-.718 0l-.755.762z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.826 7.299l1.618 1.631L13.062 7.3a4.379 4.379 0 016.225 0l2.32 2.34a4.429 4.429 0 010 6.23l-1.435-1.4a2.444 2.444 0 000-3.43l-2.32-2.34a2.355 2.355 0 00-3.355 0l-3.053 3.078L8.39 8.7a2.355 2.355 0 00-3.355 0l-2.32 2.34a2.444 2.444 0 000 3.43l4.118 4.157 4.141 4.18c.26.263.677.263.938 0l.364-.37c.231-.235.56-.57.96-.974.797-.81 1.87-1.898 2.985-3.023l1.436 1.399c-2.09 2.11-4.072 4.126-4.29 4.348l-.02.02a2.68 2.68 0 01-3.808 0l-.005-.005-.093-.094-8.161-8.238a4.43 4.43 0 010-6.23l2.32-2.34a4.379 4.379 0 016.225 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_421_3610"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));